<template>
  <v-card outlined>
    <v-card-title v-if="title">
      {{ title }}
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col v-for="option in filteredOptions" :key="option.to" cols="6">
            <v-btn
              v-bind="option.attributes"
              :to="{ name: option.to }"
              block
              large
              class="py-10"
              :color="option.color || 'primary'"
              depressed
            >
              <v-icon v-if="option.icon" left large class="mr-4">{{ option.icon }}</v-icon>
              <span class="text-h6">{{ option.text }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapMutations } from 'vuex'

export default {
  name: 'TeamSelect',
  props: {
    title: {
      type: String,
      default: undefined,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  computed: {
    filteredOptions() {
      return this.options.filter(({ to, text }) => to && text)
    },
  },
}
</script>
